export var MEDIA_DYNAMIC_GUIDELINE_PREFIX = 'media_';
export var INNER_GRID_GUIDELINE_PREFIX = 'grid_';